// extracted by mini-css-extract-plugin
export default {"nowrap":"Address_nowrap__IBGya"};